import { ErrorWrapper } from './util'

export class CommonService {
  static errorWrapper (...rest) {
    return new ErrorWrapper(...rest)
  }
}
